module.exports = __webpack_public_path__ + "static/media/ml.ac508c08.webp";